import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Card, 
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText 
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';

const About = () => {
  const values = [
    'Excelencia profesional',
    'Compromiso con el cliente',
    'Ética y transparencia',
    'Innovación continua',
    'Responsabilidad social',
    'Trabajo en equipo'
  ];

  return (
    <Box sx={{ pt: 8 }}>
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Sobre Nosotros
          </Typography>
          <Typography variant="h5">
            Conoce nuestra historia y valores
          </Typography>
        </Container>
      </Box>

      <Container sx={{ py: 8 }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', p: 3 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <BusinessIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                  <Typography variant="h4" component="h2">
                    Nuestra Historia
                  </Typography>
                </Box>
                <Typography paragraph color="text.secondary">
                  Con más de 20 años de experiencia, nuestro bufete se ha convertido en un referente
                  en el sector legal, ofreciendo servicios de la más alta calidad a nuestros clientes
                  tanto nacionales como internacionales.
                </Typography>
                <Typography paragraph color="text.secondary">
                  Fundado en el año 2000, hemos crecido de manera constante, adaptándonos a los
                  cambios del mercado y las necesidades de nuestros clientes, manteniendo siempre
                  nuestro compromiso con la excelencia y la innovación.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', p: 3 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <GroupsIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                  <Typography variant="h4" component="h2">
                    Nuestros Valores
                  </Typography>
                </Box>
                <List>
                  {values.map((value, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CircleIcon sx={{ color: 'primary.main', fontSize: 12 }} />
                      </ListItemIcon>
                      <ListItemText 
                        primary={value}
                        primaryTypographyProps={{
                          sx: { fontWeight: 500 }
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;